import type { UTCTimestamp } from "lightweight-charts";

export interface IntradayPoint {
  time: UTCTimestamp;
  value: number;
}

export function toIntradayPoint(r: {
  price: number;
  timestamp: string;
}): IntradayPoint {
  return {
    time: Math.floor(new Date(r.timestamp).getTime() / 1000) as UTCTimestamp,
    value: r.price,
  };
}

export function latestPriceFor(
  state: { byTicker: Map<string, { price: number }[]> },
  ticker: string,
): number | null {
  const rows = state.byTicker.get(ticker.toUpperCase());
  if (!rows || rows.length === 0) return null;
  return rows[rows.length - 1].price;
}
